
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2.267c.283 0 .554.112.754.312l4 4a1.067 1.067 0 01-1.508 1.509l-2.18-2.18v6.759a1.067 1.067 0 11-2.133 0V5.908l-2.179 2.18a1.067 1.067 0 11-1.508-1.509l4-4c.2-.2.471-.312.754-.312z","fill":"#CF4655"}})])
          )
        }
      }
    